import { createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import type { i18n } from 'i18next';

import { createUiI18n, type UiLanguage } from './instance';
import type { UiNamespace } from './resources';

export type UiLocale = {
    instance: i18n;
    language: UiLanguage;
    formattingLocale: 'en-ID' | 'id-ID' | undefined;
    setLanguage?: (language: UiLanguage) => void;
};

// Explicit English instance for shared controls in PhilHealth, other deployables,
// and stories. It is never passed to changeLanguage or a language detector.
export const UiLocaleContext = createContext<UiLocale>({
    instance: createUiI18n('en'),
    language: 'en',
    formattingLocale: undefined,
});

export const useUiLocale = () => useContext(UiLocaleContext);

export const useUiTranslation = <N extends UiNamespace>(namespace: N) => {
    const { instance } = useUiLocale();
    return useTranslation(namespace, { i18n: instance });
};
